<div class="centred">
  <div class="login-failed-card">
    <div class="card-item">
      <img ngSrc="./assets/dark-logo.png" alt="department logo" class="logo" height="148" width="600" priority />
    </div>
    <div class="card-item">
      <h1>Login Failed</h1>
    </div>
    <div class="card-item">
      <p>You are unable to access the following services:</p>
      <ul>
        <li>SSBA Data Collection System</li>
      </ul>
    </div>
    <div class="card-item">
      <p>You accessed these services using your Digital Identity.</p>
    </div>
    <div class="card-item">
      <p>For your privacy and security, remember to close this browser.</p>
    </div>
  </div>
</div>
